// @flow
import { unauthenticatedFetch } from '../../../api/request';

export default async function getEmailSettings(token: string) {
    return await unauthenticatedFetch(
        `/public/v5/emailSettings?token=${token}`
    );
}



// WEBPACK FOOTER //
// ./src/v5/emailSettings/api/getEmailSettings.js